import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import { createNewSegment } from './util';
var Progress = (function (_super) {
    __extends(Progress, _super);
    function Progress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            segments: []
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, showInfo = _b.showInfo, isLoading = _b.isLoading, barClassName = _b.barClassName, barStyle = _b.barStyle, completedClassName = _b.completedClassName, completedStyle = _b.completedStyle, remainingClassName = _b.remainingClassName, remainingStyle = _b.remainingStyle, infoClassName = _b.infoClassName, infoStyle = _b.infoStyle, children = _b.children, duration = _b.duration, percentage = _b.percentage, rest = __rest(_b, ["prefixCls", "className", "style", "showInfo", "isLoading", "barClassName", "barStyle", "completedClassName", "completedStyle", "remainingClassName", "remainingStyle", "infoClassName", "infoStyle", "children", "duration", "percentage"]);
            var segments = _this.state.segments;
            var containerCls = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-loading"] = isLoading,
                _a));
            var barCls = classNames(prefixCls + "-bar", barClassName);
            var completedCls = classNames(prefixCls + "-bar-completed", completedClassName);
            var remainingCls = classNames(prefixCls + "-bar-remaining", remainingClassName);
            var infoCls = classNames(prefixCls + "-info", infoClassName);
            var segmentParams = Array.isArray(percentage) ? percentage : [];
            var totalPercentage = segments.reduce(function (accu, next) { return accu + next.normalizedPercentage; }, 0);
            return (h("div", __assign({ className: containerCls, style: style, role: "progressbar", tabIndex: 0, "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": totalPercentage }, rest),
                h("div", { className: barCls, style: barStyle },
                    segments.map(function (_a, index) {
                        var normalizedPercentage = _a.normalizedPercentage, animationDuration = _a.animationDuration;
                        var _b = segmentParams[index] || {}, color = _b.color, className = _b.className, style = _b.style;
                        return (h("div", { key: index, className: classNames(completedCls, className), style: __assign(__assign(__assign({}, completedStyle), style), { width: normalizedPercentage + '%', transitionDuration: animationDuration + 'ms', backgroundColor: color }) }));
                    }),
                    h("div", { className: remainingCls, style: remainingStyle })),
                showInfo && h("div", { className: infoCls, style: infoStyle }, totalPercentage + '%')));
        };
        return _this;
    }
    Progress.getDerivedStateFromProps = function (props, state) {
        var percentage = props.percentage, duration = props.duration;
        var segments = state.segments;
        var newPercentages = Array.isArray(percentage) ? percentage.map(function (_a) {
            var value = _a.value;
            return value;
        }) : [percentage];
        var newSegments = newPercentages.map(function (segmentPercentage, index) {
            var _a;
            return createNewSegment({
                oldPercentage: (_a = segments[index]) === null || _a === void 0 ? void 0 : _a.normalizedPercentage,
                newPercentage: segmentPercentage,
                duration: duration,
            });
        });
        return {
            segments: newSegments,
        };
    };
    Progress.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Progress;
}(React.Component));
export default Progress;
Progress.defaultProps = {
    prefixCls: 'dui-progress',
    percentage: 0,
    showInfo: false,
    isLoading: false,
    duration: 10,
};
